import { configureStore } from "@reduxjs/toolkit";
//import ReduxThunk from "redux-thunk";

import rootReducer from "./reducers";

export default configureStore({
  reducer: rootReducer,
  devTools: { name: "ARES-CONTROL-CENTER" }
  //middleware: [ReduxThunk]
});
